//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getObtain, handleMedals } from './card/utils'

import Pagination from '@/common/mixins/pagination'
import Service from '@/service'
import { App_User } from '@/data/user_info'

import Loading from '@/components/views/loading'
import LeftFilter from './_components/left_filter'
import { DEFAULT_PER } from '@/config'
import cardMixin from './mixin/card'
import Item from './_components/_item'

import TopRankBanner from './_components/top_3'
import TopRankTitle from './_components/top_rank_title'
import RankBanner from './_components/rank_banner'
import RankTitle from './_components/rank_title'

import { DEFAULT_HEADIMG } from './const'

import { LEVEL_MAP } from '@/constant'

export default {
    mixins: [
        Pagination,
        cardMixin
    ],
    name: 'CONSULTANTS',
    data () {
        return {
            score_top_3_consultants: [],
            zones: [],
            select_zone: {},
            is_consultant: false,
            is_level3: false,
            medal: ''
        }
    },
    computed: {
        show_btn () {
            return this.is_consultant ? "提升排名" : "申请置业顾问入驻"
        }
    },
    onLoad ({ medal }) {
        this.medal = medal ? decodeURIComponent(medal) : ''
    },
    onReady () {
        this.is_level3 = Number(this.$route.query.zone_levels) === 3
        Service.init().then(this.getData).then(this.getZones)
        App_User.is_consultant().then((is_consultant) => {
            this.is_consultant = is_consultant
        })
    },
    onPullDownRefresh () {
        if (!this.loading) {
            this.page = 1
            this.getData()
        }
    },
    onShareAppMessage () {
        let params = ''
        if (this.is_level3) {
            params = `zone_levels=3`
        }
        return this.getShareInfo({
            title: '置业顾问',
            path: `/pages/consultants/main?${params}`
        }, 'CONSULATANT_LIST')
    },
    methods: {
        changeMedal (medal) {
            if (this.loading) {
                return
            }
            this.page = 1
            this.select_zone = {}
            this.medal = medal
            this.getData()
        },
        changeZone (select_zone) {
            if (this.loading) {
                return
            }
            this.select_zone = select_zone
            this.page = 1
            this.getData()
        },
        getZones () {
            Service.getZones().then(data => {
                let levels = ['level1', 'level2', 'level3']
                if (this.is_level3) {
                    levels = ['level3']
                }
                const zones = levels.reduce((zones, level) => {
                    zones.push(...data[level])
                    return zones
                }, [])
                this.zones = zones
            })
        },
        getData () {
            this.loading = true
            const { page, select_zone } = this
            const data = {
                page,
                per: DEFAULT_PER,
                medal: this.medal || ''
            }
            if (select_zone && select_zone.name) {
                data.zone = select_zone.name
            }
            if (this.is_level3) {
                data.zone_levels = 3
            }
            this.checkItemsClear()
            Service.getConsultants(data).then(({ items = [], score_top_3_consultants = []}) => {
                this.score_top_3_consultants = score_top_3_consultants
                items.forEach(item => {
                    item.avatar_mount_url = item.avatar_mount_url || ''
                    item.type = LEVEL_MAP[item.level]
                    item.weixin_headimgurl = item.weixin_headimgurl || DEFAULT_HEADIMG
                    item.excellect_obtain = getObtain(item, 1)
                    item.perfessional_obtain = getObtain(item, 2)
                    handleMedals(item)
                })
                this.handleData({ items })
            })
        }
    },
    components: {
        LeftFilter,
        TopRankBanner,
        TopRankTitle,
        RankTitle,
        RankBanner,
        Item,
        Loading,

    }
}
